import React, { useState } from "react";

import { setIsChatMinimized, setIsChatDocked } from "../../appRedux/actions/ChatSettings";
import { useDispatch, useSelector } from "react-redux";
import { isHoppyOrGamification } from "@util/Scripts";
import { deleteWidgetInSheet } from "../../appRedux/actions/Actions";

import IntlMessages from "@util/IntlMessages";
import projectConfig from "@projectConfig";

import "ant-design-draggable-modal/dist/index.css";
import "./style.less";
import { validateForm } from "../FormsV2/GeneralScripts";
import { useIntl } from "react-intl";
import { Message, Modal } from "../BP2Components";
import { Icon_Chat, Icon_Close } from "../BP2Components/Icons/icons";
import { useMessageItem } from "../../context/MessageItemContext/MessageItemContext";

const SettingsModal = ({
   widgetId,
   widgetName,
   children,
   icon,
   customAvatar,
   deleteIcon,
   noteWithIcon = null,
   title,
   name,
   autoOpen,
   index,
   isOpen,
   setIsOpen,
   initialWidth,
   initialHeight,
   autoHeight,
   validateBeforeOpen,
   sysButtonKey,
   className,
   showChatOptions,
   settingsChatButton,
   onClose,
}) => {
   const intl = useIntl();
   const [visible, setVisible] = useState(autoOpen ?? false);
   const { formUuid, formContextData } = useMessageItem();

   const dispatch = useDispatch();

   if (!initialHeight && !autoHeight) {
      // This is quick fix for equal. Fix this properly, in sprint 03-09-2022
      initialHeight =
         isHoppyOrGamification() && window.innerWidth < 768
            ? window.innerHeight - 130
            : !!projectConfig.bigModals
              ? 700
              : 600;
   }
   if (!initialWidth) {
      initialWidth =
         isHoppyOrGamification() && window.innerWidth < 768
            ? window.innerWidth - 10
            : !!projectConfig.bigModals
              ? 1000
              : 800;
   }
   const showModal = async (e) => {
      e.stopPropagation();
      if (validateBeforeOpen && formUuid && formContextData) {
         // TODO - Remove setting alerts from validation, it should be done before validation in fields onBlur
         const { isFormValid } = await validateForm(
            formUuid,
            sysButtonKey,
            formContextData,
            window.setFieldsInfo,
            intl,
         );

         if (!isFormValid) {
            await Message.error(intl.formatMessage({ id: "form.invalid" }));
            return;
         }

         setIsOpen ? setIsOpen(true) : setVisible(true);
         return;
      }

      setIsOpen ? setIsOpen(true) : setVisible(true);
   };

   const handleCancel = (e) => {
      setIsOpen ? setIsOpen(false) : setVisible(false);

      if (onClose) {
         onClose();
      }
   };

   const deleteItem = (e) => {
      e.stopPropagation();
      dispatch(deleteWidgetInSheet(widgetId));
   };

   const { isChatDocked } = useSelector(({ settings }) => settings);
   const { isChatMinimized } = useSelector(({ chatSettings }) => chatSettings);

   const handleMinimizeChat = () => {
      dispatch(setIsChatMinimized());
   };

   const setChatModalClassName = () => {
      if (isChatDocked) {
         if (isChatMinimized) {
            return "chat-modal-hidden";
         } else {
            return "chat-modal docked-mod";
         }
      } else {
         if (isChatMinimized) {
            return "chat-modal-hidden";
         } else {
            return "chat-modal";
         }
      }
   };
   const widgetTitleInfo = () => {
      let capitalizedWidgetName = "";
      if (widgetName) {
         capitalizedWidgetName = widgetName[0].toUpperCase() + widgetName?.slice(1);
         capitalizedWidgetName = capitalizedWidgetName.replace(/\s/g, "");
      }

      return (
         <>
            {(widgetName || icon === "setting") && (
               <>
                  <IntlMessages id="settings" />
                  {widgetName && (
                     <span className="widget-title-info">
                        "<IntlMessages id={`sidebar.right.${capitalizedWidgetName}`} />"
                     </span>
                  )}
               </>
            )}
         </>
      );
   };

   // Copy selected widget and add as the last elemnent on current sheet - the id of a sheet is generated during it's creation therefore it has to be set here
   if (autoOpen !== true) {
      return (
         <>
            <>
               {noteWithIcon !== null && (
                  <span
                     className=" span-style gx-text-primary"
                     onClick={showModal}
                     id={`action-notewithicon-${widgetId}-${index}`}
                  >
                     {noteWithIcon}
                  </span>
               )}
               {icon && (
                  <span
                     id={widgetId ? `action-icon-${widgetId}-${index}` : `settings-board-icon`}
                     onClick={showModal}
                     className={`${className} gx-text-primary span-style settings-board-icon icon icon-${icon}`}
                  />
               )}
               {
                  <span
                     onClick={showModal}
                     className="span-style gx-text-primary"
                     id={`action-customAvatar-${widgetId}-${index}`}
                  >
                     {customAvatar}
                  </span>
               }
               {name ? (
                  <span
                     onClick={showModal}
                     className="span-style gx-text-primary"
                     id={`action-name-${widgetId}-${index}`}
                  >
                     {name}
                  </span>
               ) : null}
            </>
            {deleteIcon === "true" ? (
               <span
                  onClick={deleteItem}
                  className="icon icon-close span-style gx-text-primary hide-on-mobile"
               />
            ) : (
               ""
            )}
            <Modal
               topBarContent={title ? title : widgetTitleInfo()}
               isOpen={isOpen ?? visible}
               wrapClassName={className ?? "custom-modal"}
               key={widgetId}
               width={initialWidth}
               height={initialHeight}
               onCancel={handleCancel}
               backgroundShadow={true}
            >
               {children}
            </Modal>
         </>
      );
   } else {
      const minimizeChat = (
         <div className="chat-modal-header">
            {settingsChatButton}
            <div className="open-chat-icon-wrapper">
               <div className="open-chat-icon">
                  <Icon_Chat fill="none" stroke="white" />
               </div>
               <h6 className="chat-name">
                  <IntlMessages id="sidebar.right.ChatSettings" />
               </h6>
            </div>
            <div className="modal-icon-chat-wrap">
               <div className="minimize-chat" onClick={handleMinimizeChat}>
                  <span className="minimize-chat-btn">
                     <Icon_Close fill="none" stroke="#64748b" />
                  </span>
               </div>
            </div>
            {showChatOptions && showChatOptions()}
         </div>
      );

      return (
         <>
            <Modal
               topBarContent={minimizeChat}
               isOpen={isOpen ?? visible}
               width={initialWidth}
               height={initialHeight}
               className={setChatModalClassName()}
               backgroundShadow={false}
               wrapClassName={className}
            >
               {children}
            </Modal>
         </>
      );
   }
};

export default SettingsModal;
